export enum TicketCheckinUploadStatus {
  UNPUSHED = 'unpushed',
  PUSHED = 'pushed',
}
